import type { PrimitiveValue, PrimitiveValueName } from "@skilitics/nautilus-core";

/**
 * The value a configured value of this type falls back to: the seed for a new
 * static config, and the baked fallback for a published runtime reference with no
 * design-time value (no `designTime` spec, a dangling/cyclic resolution, or a
 * missing external-value registry entry).
 */
export const defaultValueForConfig = (type: PrimitiveValueName): PrimitiveValue => {
  switch (type) {
    case "string":
      return "";
    case "number":
      return 0;
    case "boolean":
      return false;
  }
};
